'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ../math-intrinsics/abs.js
// module id = 525
// module chunks = 0